import { render, staticRenderFns } from "./tutortraindal.vue?vue&type=template&id=aa1568ea&"
import script from "./tutortraindal.vue?vue&type=script&lang=js&"
export * from "./tutortraindal.vue?vue&type=script&lang=js&"
import style0 from "./tutortraindal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports